"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ImagePlaceholder", {
  enumerable: true,
  get: function () {
    return _ImagePlaceholder.ImagePlaceholder;
  }
});
var _ImagePlaceholder = require("./ImagePlaceholder");
//# sourceMappingURL=index.js.map